<script setup lang="ts"></script>

<template>
  <div class="previous-month-day-tile-view" />
</template>

<style scoped lang="scss">
.previous-month-day-tile-view {
  width: var(--calendar-tile-size);
  height: var(--calendar-tile-size);
}
</style>
